import { FC } from "react";

import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import IconButton from "@mui/material/IconButton";
import Divider from "@mui/material/Divider";

import styles from "./styles";

interface SectionOrdinalsProps {
  id: string;
  ownedBy: string;
  created: string;
  creationBlock: string;
  creationTx: string;
  creationFee: string;
  tags: string[];
  satNumber: string;
  satName: string;
  satCreationBlock: string;
  satCreationYear: string;
  inscriptions: string[];
  cursedInscriptions: string;
  satributes: string[];
}

const copyToClipboard = (text: string) => {
  navigator.clipboard.writeText(text);
};

const cutText = (text: string) => {
  return (
    text.substring(0, 5) + "..." + text.substring(text.length - 5, text.length)
  );
};

const SectionOrdinals: FC<SectionOrdinalsProps> = ({
  id,
  ownedBy,
  created,
  creationBlock,
  creationTx,
  creationFee,
  tags,
  satNumber,
  satName,
  satCreationBlock,
  satCreationYear,
  inscriptions,
  cursedInscriptions,
  satributes,
}) => {
  return (
    <Box display="grid" gap={4}>
      <Box
        display="grid"
        gap={0}
        sx={{ backgroundColor: "rgba(255, 255, 255, 0.05)", p: 2 }}
      >
        <Box sx={styles.box1}>
          <Typography>ID</Typography>
          <IconButton onClick={() => copyToClipboard(id)}>
            <ContentCopyIcon sx={styles.copyIcon} />
          </IconButton>
        </Box>
        <Typography component="div" sx={styles.info}>
          {cutText(id)}
        </Typography>
        <Divider sx={{ my: 1 }} />

        <Box sx={styles.box1}>
          <Typography>OWNED BY</Typography>
          <IconButton onClick={() => copyToClipboard(ownedBy)}>
            <ContentCopyIcon sx={styles.copyIcon} />
          </IconButton>
        </Box>
        <Typography component="div" sx={styles.info2}>
          {ownedBy}
        </Typography>
        <Divider sx={{ my: 1 }} />

        <Box sx={styles.box1}>
          <Typography>CREATED</Typography>
        </Box>
        <Typography component="div" sx={styles.info}>
          {created}
        </Typography>
        <Divider sx={{ my: 1 }} />

        <Box sx={styles.box1}>
          <Typography>CREATION BLOCK</Typography>
          <IconButton onClick={() => copyToClipboard(creationBlock)}>
            <ContentCopyIcon sx={styles.copyIcon} />
          </IconButton>
        </Box>
        <Typography component="div" sx={styles.info2}>
          {creationBlock}
        </Typography>
        <Divider sx={{ my: 1 }} />

        <Box sx={styles.box1}>
          <Typography>CREATION TRANSACTION</Typography>
          <IconButton onClick={() => copyToClipboard(creationTx)}>
            <ContentCopyIcon sx={styles.copyIcon} />
          </IconButton>
        </Box>
        <Typography component="div" sx={styles.info2}>
          {cutText(creationTx)}
        </Typography>
        <Divider sx={{ my: 1 }} />

        <Box sx={styles.box1}>
          <Typography>CREATION FEE</Typography>
        </Box>
        <Typography component="div" sx={styles.info}>
          {creationFee} sats
        </Typography>
        <Divider sx={{ my: 1 }} />

        <Box sx={styles.box1}>
          <Typography>TAGS</Typography>
        </Box>
        <Box sx={{ display: "flex" }}>
          {tags.map((tag, i) => (
            <Box key={i} sx={styles.tag}>
              {tag}
            </Box>
          ))}
        </Box>
      </Box>

      <Box
        display="grid"
        gap={0}
        sx={{ backgroundColor: "rgba(255, 255, 255, 0.05)", p: 2 }}
      >
        <Typography sx={{ fontWeight: "700", fontSize: "22px" }}>
          Sat
        </Typography>
        <Box sx={styles.box1}>
          <Typography>SAT NUMBER</Typography>
          <IconButton onClick={() => copyToClipboard(satNumber)}>
            <ContentCopyIcon sx={styles.copyIcon} />
          </IconButton>
        </Box>
        <Typography component="div" sx={styles.info}>
          {satNumber}
        </Typography>
        <Divider sx={{ my: 1 }} />

        <Box sx={styles.box1}>
          <Typography>SAT NAME</Typography>
        </Box>
        <Typography component="div" sx={styles.info}>
          {satName}
        </Typography>
        <Divider sx={{ my: 1 }} />

        <Box sx={styles.box1}>
          <Typography>SAT CREATION BLOCK</Typography>
        </Box>
        <Typography component="div" sx={styles.info2}>
          {satCreationBlock}
        </Typography>
        <Divider sx={{ my: 1 }} />

        <Box sx={styles.box1}>
          <Typography>SAT CREATION YEAR</Typography>
        </Box>
        <Typography component="div" sx={styles.info}>
          {satCreationYear}
        </Typography>
        <Divider sx={{ my: 1 }} />

        <Box sx={styles.box1}>
          <Typography>INSCRIPTIONS</Typography>
        </Box>
        <Box sx={{ display: "flex" }}>
          {inscriptions.map((inscription, i) => (
            <Box key={i} sx={styles.tag}>
              {inscription}
            </Box>
          ))}
        </Box>
        <Divider sx={{ my: 1 }} />

        <Box sx={styles.box1}>
          <Typography>CURSED INSCRIPTIONS</Typography>
        </Box>
        <Typography component="div" sx={styles.info}>
          {cursedInscriptions}
        </Typography>
        <Divider sx={{ my: 1 }} />

        <Box sx={styles.box1}>
          <Typography>SATRIBUTES</Typography>
        </Box>
        <Box sx={{ display: "flex" }}>
          {satributes.map((satribute, i) => (
            <Box key={i} sx={styles.tag}>
              {satribute}
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default SectionOrdinals;
